import React, { PureComponent, ReactNode } from 'react';
import { Flex } from '../../../common/Flex';
import {
    ArrowDownOutlined,
    ArrowUpOutlined,
    CheckCircleOutlined,
    DeleteFilled,
    MinusSquareFilled,
    PlusSquareFilled,
} from '@ant-design/icons';
import { Input } from 'antd';

interface FlowSectionHeaderProps {
    title: string;
    onTitleChange?(title: string): void;
    folded: boolean;
    onFoldedChange?(folded: boolean): void;

    nbTvs?: number;
    nbTvSets?: number;

    moveUpEnabled?: boolean;
    moveDownEnabled?: boolean;
    deleteEnabled?: boolean;

    onMoveUp?(): void;
    onMoveDown?(): void;
    onDeleteSection?(): void;

    extraActions?: Array<ReactNode>; // Extra components that are displayed in the top right action bar
}

interface FlowSectionHeaderState {
    editMode: boolean;
    title: string;
}

const disabledIconStyle = { opacity: '0.3', cursor: 'not-allowed' };

export class FlowSectionHeader extends PureComponent<FlowSectionHeaderProps, FlowSectionHeaderState> {
    state = {
        editMode: false,
        title: undefined,
    };

    handleMoveUp = () => {
        this.props.onMoveUp?.();
    };

    handleMoveDown = () => {
        this.props.onMoveDown?.();
    };

    handleDelete = () => {
        this.props.onDeleteSection?.();
    };

    handleTitleChange = () => {
        this.setState({ editMode: false }, () => this.props.onTitleChange(this.state.title));
    };

    handleTitleClick = () => {
        if (this.props.onTitleChange) {
            // No callback function means that title cannot be edited
            this.setState({ editMode: true, title: this.props.title });
        }
    };

    handleTitleInputChange = e => {
        this.setState({ title: e.currentTarget.value });
    };

    handleFoldUnfold = () => {
        this.props.onFoldedChange?.(!this.props.folded);
    };

    renderTitle = () => {
        if (this.state.editMode) {
            return (
                <Input
                    value={this.state.title}
                    onChange={this.handleTitleInputChange}
                    onKeyPress={e => e.key === 'Enter' && this.handleTitleChange()}
                    suffix={<CheckCircleOutlined style={{ fontSize: '1.5em' }} onClick={this.handleTitleChange} />}
                />
            );
        }
        return <span onClick={this.handleTitleClick}>{this.props.title}</span>;
    };

    renderSubTitle = () => {
        if (!this.props.nbTvs && !this.props.nbTvSets) return null;

        return (
            <>
                {this.props.nbTvs || 0} TFVs - {this.props.nbTvSets || 0} clusters
            </>
        );
    };

    render() {
        return (
            <Flex style={{ marginBottom: '1em' }}>
                <hr className="horizontal-dash-line" />
                <Flex className="flow-section-title" direction="vertical" style={{ flex: 'none' }}>
                    <div style={{ padding: '0.25em', fontWeight: 'bold' }}>{this.renderTitle()}</div>
                    <div style={{ padding: '0.25em' }}>{this.renderSubTitle()}</div>
                </Flex>
                <hr className="horizontal-dash-line" />
                <Flex className="flow-section-actions show-on-hover" style={{ left: 0 }}>
                    {this.props.folded ? (
                        <PlusSquareFilled onClick={this.handleFoldUnfold} />
                    ) : (
                        <MinusSquareFilled onClick={this.handleFoldUnfold} />
                    )}
                    <ArrowUpOutlined
                        style={this.props.moveUpEnabled ? {} : disabledIconStyle}
                        onClick={this.handleMoveUp}
                    />
                    <ArrowDownOutlined
                        style={this.props.moveDownEnabled ? {} : disabledIconStyle}
                        onClick={this.handleMoveDown}
                    />
                    <DeleteFilled
                        style={this.props.deleteEnabled ? {} : disabledIconStyle}
                        onClick={this.handleDelete}
                    />
                </Flex>
                <Flex className="flow-section-actions show-on-hover" style={{ right: '1em' }}>
                    {this.props.extraActions}
                </Flex>
            </Flex>
        );
    }
}
